import { PreferenceImageLoaderCSSStyleImpl } from './prefernceimageloadercss';
import { MultiselectCategoryCardViewImpl } from '../../../login/createaccountcomponent/categorylist/viewmodel/categorycard/multiselectcategorycardview';
import { PreferenceCheckboxCSSStyleImpl } from './preferencecategorycheckboxcss';
import { MultiselectCategoryCardComponentProps } from '../../../login/createaccountcomponent/categorylist/viewmodel/categorycard/multiselectcategorycardcomponent';
import { UIComponentState } from '../../../../toolkit/uicomponent';
import { MultiselectCategoryCardCSSStyle } from '../../../login/createaccountcomponent/categorylist/viewmodel/categorycard/multiselectcategorycardcssstyle';
import * as React from 'react';
import { ImageLoaderComponent } from '../../../../toolkit/imageloader/imageloadercomponent';
import { CheckboxComponent } from '../../../../toolkit/checkbox/checkboxcomponent';


export class PreferenceCategoryCardViewImpl extends MultiselectCategoryCardViewImpl
{
    draw(props: MultiselectCategoryCardComponentProps, state: UIComponentState, cssStyle: MultiselectCategoryCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div key={props.position} className="swiper-slide" style={{height:"200px"}}>
            <div style={cssStyle.getWrapperCSSStyle()}>
                <div style={cssStyle.getTintDivCSSStyle()} />
                    {/* <img alt="" src={props.categoryDto.getImgPath()} style={cssStyle.getImgCSSStyle()}/> */}
                    <ImageLoaderComponent defaultImageName={"category_default_image.jpg"} imagePath={props.categoryDto.getImgPath()} imageLoaderCSSStyle={new PreferenceImageLoaderCSSStyleImpl(props.context)} context={props.context}/> 
                    {<div style={cssStyle.getCheckboxCSSStyle()}>
                        <CheckboxComponent isEditable={props.isEditable} style={new PreferenceCheckboxCSSStyleImpl(props.context)} onChange={this.onSelected} context={props.context} isChecked={props.isSelected}/>
                    </div>}

                <div style={cssStyle.getTitleCSSStyle()}>
                    {props.categoryDto.getTitle()}
                </div>
            </div>
        </div>    
        );
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/preferences/preferenccard/preferencecategorycardview.tsx